import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WorksSection from './components/WorksSection';
import RankingSection from './components/RankingSection';
import LibrarySection from './components/LibrarySection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg hover:bg-primary-600 transition-all ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

function AboutBand() {
  return (
    <section className="w-full py-12 md:py-16 bg-foreground-900 text-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <p className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
            <i className="ri-quill-pen-line"></i>
            关于本站
          </p>
          <h2 className="font-heading text-2xl md:text-3xl leading-snug">
            为每一位漫画爱好者打造的找漫画神器
          </h2>
          <p className="mt-4 text-foreground-300 text-sm md:text-base leading-relaxed">
            4399漫画网把"找漫画"这件事做到极致。我们把全站作品按热血、恋爱、玄幻、悬疑等类型做精细分类，
            并用热门排行、新上架作品、完结作品库和强大搜索四大工具帮你快速定位。无论是追更连载，还是重温完结经典，
            都能在几秒内找到想看的作品。
          </p>
          <div className="mt-6 flex flex-wrap gap-2.5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-700 text-foreground-200 text-xs">
              <i className="ri-search-line text-primary-400"></i> 精准搜索
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-700 text-foreground-200 text-xs">
              <i className="ri-grid-fill text-accent-400"></i> 全品类分类
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-700 text-foreground-200 text-xs">
              <i className="ri-refresh-line text-secondary-400"></i> 实时更新
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {[
            { num: '1.2万+', label: '收录漫画作品', icon: 'ri-stack-fill' },
            { num: '50+', label: '细分类型分类', icon: 'ri-price-tag-3-fill' },
            { num: '8亿+', label: '累计阅读量', icon: 'ri-eye-fill' },
            { num: '99.2%', label: '用户满意度', icon: 'ri-heart-fill' },
          ].map((stat) => (
            <div key={stat.label} className="p-5 rounded-2xl bg-foreground-800 border border-foreground-700">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center text-lg mb-3">
                <i className={stat.icon}></i>
              </span>
              <p className="font-heading text-2xl md:text-3xl text-accent-400">{stat.num}</p>
              <p className="mt-1 text-xs text-foreground-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  const [keyword, setKeyword] = useState('');

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar searchKeyword={keyword} onSearch={setKeyword} />
      <main>
        <Hero />
        <WorksSection keyword={keyword} onKeywordChange={setKeyword} />
        <RankingSection />
        <LibrarySection />
        <AboutBand />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}